module.exports = __webpack_public_path__ + "media/images/flt-logo-a522266eb6e6beb7caa5e6d5b0203fc2.png";